export function getConfig() {
  // Use REACT_APP_ prefixed environment variables for Auth0 configuration
  // These are the only environment variables available at runtime in the browser
  const domain = process.env.REACT_APP_AUTH_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH_CLIENTID;
  const audience = process.env.REACT_APP_AUTH_AUDIENCE;

  if (!domain || !clientId) {
    console.warn("Auth0 environment variables not set. Please configure REACT_APP_AUTH_DOMAIN and REACT_APP_AUTH_CLIENTID in Cloudflare Pages.");
    return {
      domain: domain || "your-domain.auth0.com",
      clientId: clientId || "your-client-id",
    };
  }

  // If audience is properly configured, include it for better security
  if (audience && audience !== "todo" && audience !== "{yourApiIdentifier}" && audience !== "") {
    return {
      domain,
      clientId,
      audience,
    };
  }

  // Fallback without audience (less secure but works)
  return {
    domain,
    clientId,
  };
}
